import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListarMatriculas = ({ id }) => {
  const [matriculas, setMatriculas] = useState([]);
  const navigate = useNavigate();




  const getData = useCallback(async () => {
    try {
      const { data } = await axios.get('/api/matriculas/listall/');
      const matriculasConFunciones = data.matriculas.map((matricula) => {
        return {
          ...matricula,
          estadoMatricula: matricula.estadoMatricula,
          fichaGrupo: matricula.grupoObjectId?.fichaGrupo || 'Sin asignar',
          nombrePrograma: matricula.grupoObjectId?.programaObjectId?.nombrePrograma || 'Sin programa',
          cantCuposGrupo: matricula.grupoObjectId?.cantCuposGrupo || 'N/A',
          fechaCreacion: new Date(matricula.fechaCreacion).toLocaleDateString(),
          cantidadMatriculados: matricula.cantidadMatriculados || 0,
          funciones: (
            <div className="d-flex gap-2">

              <button
                className="btn btn-success ms-2"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/etapaproductiva/seguimiento/registromasivo/${matricula._id}` )}
                title="Registrar Seguimientos Masivos"
              >

                <i className="fa-solid fa-file-pen "></i>
              </button>

              <button
                className="btn btn-primary"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/etapaproductiva/bitacoras/registromasivo/${matricula._id}`)}
                title="Registrar Bitácoras Masivas"
              >
                <i className="fa-solid fa-book"></i>
              </button>


              <button
                className="btn btn-primary"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/etapaproductiva/registromasivo/${matricula._id}`)}
                title="Registrar Etapa Productiva Masiva">
                <i className="fa-solid fa-briefcase"></i>
              </button>

              <button
                className="btn btn-warning d-flex align-items-center justify-content-center"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/matricula/editar/${matricula._id}`)}
                title="Editar Matrícula"
              >

                <i className="fa-solid fa-edit" />
              </button>

              <button
                className="btn btn-success"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/actividad/registrar/${matricula._id}`)}
                title="Registrar Asistencia"
              >
                <i className="fa-solid fa-clipboard-check"></i>
              </button>

              <button
                className="btn btn-secondary btn-sm"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => navigate(`/matricula/listarmatriculados/${matricula._id}`)}
                title="Ver Matriculados"
              >
                <i className="fa-solid fa-users fa-lg"></i>
              </button>

              <button
                className="btn btn-danger"
                style={{ width: 30, height: 30, padding: 0 }}
                onClick={() => deleteMatricula(matricula._id)}
                title="Eliminar Matrícula"
              >
                <i className="fa-solid fa-trash"></i>
              </button>

            </div>
          ),
        };
      });


      setMatriculas(matriculasConFunciones);
    } catch (error) {
      console.error('Error al cargar las matrículas:', error.message);
    }
    // eslint-disable-next-line 
  }, []);


  useEffect(() => {
    getData();
  }, [getData]);

  // Función para eliminar una matrícula
  const deleteMatricula = async (id) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar!',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/matriculas/${id}`);
          getData(); // Refrescar los datos
          Swal.fire({
            icon: 'success',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar la matrícula:', error.message);
      Swal.fire('Error', 'No se pudo eliminar la matrícula.', 'error');
    }
  };

  const columns = React.useMemo(
    () => [
      //{ Header: 'Código', accessor: 'codMatricula' },
      //{ Header: "Fecha", accessor: "fechaCreacion" },
      { Header: "Año", accessor: "anioLectivo" },
      { Header: "Grupo", accessor: "fichaGrupo" },
      { Header: "Programa", accessor: "nombrePrograma" },
      { Header: "Solicitados", accessor: "cantCuposGrupo" },
      { Header: "Matriculados", accessor: "detallesCount" }, // Mostrar conteo.
      { Header: "Deserciones", accessor: "cantidadDesertados" },
      { Header: "Traslados", accessor: "cantidadTraslados" },
      { accessor: 'funciones' },
    ], []
  );

  return (
    <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-5">
      <h1>Listado de Matrículas</h1>
      {Array.isArray(matriculas) && matriculas.length > 0 ? (
        <DataTable columns={columns} data={matriculas} />
      ) : (
        <p>Cargando Matrículas...</p>
      )}
    </div>
  );
};

export default ListarMatriculas;
